document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.marquee-inner').forEach(function (marquee) {
        marquee.innerHTML += marquee.innerHTML;

        const totalWidth = Math.round(marquee.scrollWidth / 2);
        const isLogoMarquee = marquee.closest('.marquee-block');
        const isSmallScreen = window.matchMedia('(max-width: 1400px)').matches;
        const duration = isLogoMarquee && isSmallScreen ? 120 : 90;

        gsap.to(marquee, {
            x: -totalWidth,
            duration: duration,
            ease: "none",
            repeat: -1,
            modifiers: {
                x: gsap.utils.unitize(x => parseFloat(x) % totalWidth)
            }
        });
    });
});
